export default value => Boolean(value.match(/^[A-Z][0-9]{8}/gi))
